import {updateToolCall} from "../../../../../../../contextManagement/toolCallUpdater.ts";
import {addToolMessage} from "../../../utils/utils.ts";

export const handleDocumentMessage = (args: any, llmRequestRefs: any, finishedToolCall: any, setMessages: any, updateElementInProgress: any, currentMessageRef: any, messagesSequenceRef: any, messagesRef: any) => {
    const handleFinish = (results: any) => {
        addToolMessage(finishedToolCall, results, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);
        updateElementInProgress(finishedToolCall.id, 'delete');
    }

    if (args.type === "status") {
        updateToolCall(llmRequestRefs, finishedToolCall.id, { status: { message: args.message } });
        setMessages((prev: any) => prev.deepCopy());
    }
    else if (args.type === "done") {
        updateToolCall(llmRequestRefs, finishedToolCall.id, { status: null });
        updateToolCall(llmRequestRefs, finishedToolCall.id, { docUrl: args.docUrl });
        handleFinish({docUrl: args.docUrl});
    }
    else if (args.type === "error") {
        updateToolCall(llmRequestRefs, finishedToolCall.id, { status: null });
        handleFinish({docUrl: "ERROR GENERATING DOCUMENT"});
    }
}